import { render, staticRenderFns } from "./WDDashboardSummaryBDM.vue?vue&type=template&id=eca4c470&scoped=true&"
import script from "./WDDashboardSummaryBDM.vue?vue&type=script&lang=js&"
export * from "./WDDashboardSummaryBDM.vue?vue&type=script&lang=js&"
import style0 from "./WDDashboardSummaryBDM.vue?vue&type=style&index=0&id=eca4c470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca4c470",
  null
  
)

export default component.exports